import React from 'react';
import { Box, Typography } from '@mui/material';
import { TournamentSlot as TournamentSlotSVG } from '../../../assets/images/tournamentSlot';
import { useTheme } from '@mui/material/styles';
/**
 * TournamentSlot Component
 * @param {Object} props
 * @param {string} props.text - 슬롯에 표시할 텍스트
 * @param {string} props.prop - 슬롯 상태: "패배" | "대기" | "승리" | "등록전" | "empty" | "승리-1"
 * @param {Object} props.sx - 추가 스타일
 * @param {Object} props...props - 기타 props
 */
export const TournamentSlot = ({ text = "승리", prop = "empty", sx = {}, ...props }) => {
    const theme = useTheme();
    const containerStyles = {
        position: 'relative',
        width: '84px',
        height: '20px',
        ...sx
    };

    const textStyles = {
        position: 'absolute',
        top: '50%',
        left: 'calc(50% + 0.5px)',
        transform: 'translate(-50%, -50%)',
        width: '73px',
        fontSize: '12px',
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: '-0.36px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
    };

    if (prop === "패배") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    inset: 0
                }}>
                    <TournamentSlotSVG
                        fill={theme.palette.figma.white[10]}
                        stroke="transparent"
                    />
                </Box>
                <Typography sx={{
                    ...textStyles,
                    color: theme.palette.figma.white[60]
                }}>
                    {text}
                </Typography>
            </Box>
        );
    }

    // 등록전 상태
    if (prop === "등록전") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    inset: 0
                }}>
                    <TournamentSlotSVG
                        fill={theme.palette.figma.white[40]}
                        stroke="transparent"
                    />
                </Box>
                <Typography sx={{
                    ...textStyles,
                    color: theme.palette.figma.buttonText
                }}>
                    {text}
                </Typography>
            </Box>
        );
    }

    // 대기 상태
    if (prop === "대기") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    inset: 0
                }}>
                    <TournamentSlotSVG
                        fill={theme.palette.figma.didim}
                        stroke="transparent"
                    />
                </Box>
                <Typography sx={{
                    ...textStyles,
                    color: theme.palette.figma.iconWhite
                }}>
                    {text}
                </Typography>
            </Box>
        );
    }

    // 승리 상태
    if (prop === "승리") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    inset: 0
                }}>
                    <TournamentSlotSVG
                        fill={theme.palette.figma.Red_didim}
                        stroke="transparent"
                    />
                </Box>
                <Typography sx={{
                    ...textStyles,
                    color: theme.palette.figma.iconWhite
                }}>
                    {text}
                </Typography>
            </Box>
        );
    }

    // 승리-1 상태 (반투명)
    if (prop === "승리-1") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    inset: 0
                }}>
                    <TournamentSlotSVG
                        fill={theme.palette.figma.Red_didim}
                        fillOpacity="0.6"
                        stroke="transparent"
                    />
                </Box>
                <Typography sx={{
                    ...textStyles,
                    color: theme.palette.figma.iconWhite,
                    opacity: 0.6
                }}>
                    {text}
                </Typography>
            </Box>
        );
    }

    // 기본 상태 (empty)
    return (
        <Box sx={containerStyles} {...props}>
            <Box sx={{
                position: 'absolute',
                inset: 0
            }}>
                <TournamentSlotSVG
                    fill={theme.palette.figma.white[10]}
                    stroke={theme.palette.figma.white[30]}
                />
            </Box>
            <Typography sx={{
                ...textStyles,
                color: theme.palette.figma.white[40]
            }}>
                승리
            </Typography>
        </Box>
    );
};

export default TournamentSlot;
